import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Check, Unlock, Database, MessageCircle, BarChart3 } from "lucide-react";

const differentials = [
  {
    icon: Unlock,
    title: "Sem Fidelidade",
    description: "Liberdade absoluta para cancelar quando quiser.",
  },
  {
    icon: Database,
    title: "Dados que Acumulam",
    description: "O que você não usa, fica para o mês seguinte.",
  },
  {
    icon: MessageCircle,
    title: "WhatsApp Incluso",
    description: "Use o app sem descontar da sua franquia de dados.",
  },
  {
    icon: BarChart3,
    title: "Painel de Gestão",
    description: "Controle unificado de custos e consumo em tempo real.",
  },
];

const ARPMobileSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="arpmobile"
      className="py-20 lg:py-32 bg-brand-dark relative overflow-hidden"
      data-testid="arpmobile-section"
      ref={ref}
    >
      {/* Background decorations */}
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-brand-ruby/10 rounded-full blur-[150px] transform -translate-y-1/2" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <span className="inline-block px-4 py-2 bg-brand-ruby/10 text-brand-ruby text-sm font-bold tracking-wider uppercase rounded-full mb-4">
              ARPMobile
            </span>

            <h2 className="font-montserrat font-black text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight mb-6">
              Chega de burocracia com{" "}
              <span className="text-brand-ruby">operadoras tradicionais</span>.
            </h2>

            <p className="text-white/60 text-base sm:text-lg mb-8 max-w-xl">
              Telefonia B2B com liberdade, transparência e controle total para sua empresa.
            </p>

            {/* Feature chips */}
            <div className="flex flex-wrap gap-3">
              <span className="px-4 py-2 bg-brand-gray rounded-full text-white/80 text-sm font-medium">
                📶 5G de Alta Velocidade
              </span>
              <span className="px-4 py-2 bg-brand-gray rounded-full text-white/80 text-sm font-medium">
                🔒 Segurança Empresarial
              </span>
              <span className="px-4 py-2 bg-brand-gray rounded-full text-white/80 text-sm font-medium">
                💼 Gestão Centralizada
              </span>
            </div>
          </motion.div>

          {/* Right Content - Differentials */}
          <motion.div
            className="space-y-4"
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {differentials.map((item, index) => (
              <motion.div
                key={item.title}
                className="flex items-start gap-4 p-5 bg-brand-gray/50 border border-white/10 rounded-xl hover:border-brand-ruby/30 transition-all duration-300"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
                data-testid={`arpmobile-feature-${index}`}
              >
                <div className="flex-shrink-0 w-10 h-10 bg-brand-ruby/20 rounded-lg flex items-center justify-center">
                  <Check className="w-5 h-5 text-brand-ruby" />
                </div>
                <div>
                  <h3 className="font-bold text-lg text-white mb-1">
                    {item.title}
                  </h3>
                  <p className="text-sm text-white/60">{item.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ARPMobileSection;
